import { createFileRoute } from '@tanstack/react-router';
import { ArticlePage } from '../components/community/ArticlePage';

export const Route = createFileRoute('/community/articles/$articleId')({
  component: ArticlePage,
});
